import { Checkbox, Radio, Space } from 'antd';

import { QuestionAlternativeCollection } from '../../types';

interface CandidateAnswerAlternativesProps {
  questionType: string;
  questionAlternatives?: QuestionAlternativeCollection[];
  answerAlternatives?: QuestionAlternativeCollection['id'][];
}

const CandidateAnswerAlternatives = ({
  questionType,
  questionAlternatives,
  answerAlternatives,
}: CandidateAnswerAlternativesProps) => {
  return (
    <Space direction="vertical" size="middle">
      {questionAlternatives?.map((questionAlternative) => {
        if (questionType === 'RADIO')
          return (
            <Radio
              disabled
              checked={
                answerAlternatives ? answerAlternatives.includes(questionAlternative.id) : false
              }
              key={questionAlternative.id}
            >
              {questionAlternative.description}
            </Radio>
          );

        if (questionType === 'CHECKBOX')
          return (
            <Checkbox
              disabled
              checked={
                answerAlternatives ? answerAlternatives.includes(questionAlternative.id) : false
              }
              key={questionAlternative.id}
            >
              {questionAlternative.description}
            </Checkbox>
          );

        return <></>;
      })}
    </Space>
  );
};

export default CandidateAnswerAlternatives;
